import { createAction, props } from '@ngrx/store';
import {NutritionAssignment, NutritionLocation, NutritionSaveRequest} from '@emm/core/models/nutrition.model';


export enum NutritionAction {
    InitNutrition = '[Nutrition] Init Nutrition',
    LoadAssignments = '[Nutrition] Load Profile Assignments',
    LoadAssignmentsFailure = '[Nutrition API] Load Profile Assignments Failure',
    LoadAssignmentsSuccess = '[Nutrition API] Load Profile Assignments Success',
    LoadProfileOptions = '[Nutrition] Load Profile Options',
    LoadProfileOptionsFailure = '[Nutrition API] Load Profile Options Failure',
    LoadProfileOptionsSuccess = '[Nutrition API] Load Profile Options Success',
    SaveLocationAssignment = '[Nutrition] Save Location Assignment',
    SaveLocationAssignmentFailure = '[Nutrition API] Save Location Assignment Failure',
    SaveLocationAssignmentSuccess = '[Nutrition API] Save Location Assignment Success',
    SelectAssignment = '[Nutrition] Select Assignment',
    SelectDate = '[Nutrition] Select Date',
    SelectNutritionLocation = '[Nutrition] Select Location',
    SelectNutritionLocationSetType = '[Nutrition] Select Location Set Type',
    SelectNutritionLocationSetTypeSuccess = '[Nutrition] Select Location Set Type Success',
    UnselectLocation = '[Nutrition] Unselect Location'
}

export const NutritionActions = {
    initNutrition: createAction(NutritionAction.InitNutrition),
    loadAssignments: createAction(NutritionAction.LoadAssignments),
    loadAssignmentsFailure: createAction(NutritionAction.LoadAssignmentsFailure, props<{ error: any }>()),
    loadAssignmentsSuccess: createAction(NutritionAction.LoadAssignmentsSuccess, props<{ assignments: NutritionAssignment[] }>()),
    loadProfileOptions: createAction(NutritionAction.LoadProfileOptions),
    loadProfileOptionsFailure: createAction(NutritionAction.LoadProfileOptionsFailure, props<{ error: any }>()),
    loadProfileOptionsSuccess: createAction(NutritionAction.LoadProfileOptionsSuccess, props<{ profileOptions: number[] }>()),
    saveLocationAssignment: createAction(NutritionAction.SaveLocationAssignment, props<{ apiData: NutritionSaveRequest }>()),
    saveLocationAssignmentFailure: createAction(NutritionAction.SaveLocationAssignmentFailure, props<{ error: any }>()),
    saveLocationAssignmentSuccess: createAction(NutritionAction.SaveLocationAssignmentSuccess, props<{ apiData: NutritionSaveRequest }>()),
    selectAssignment: createAction(NutritionAction.SelectAssignment, props<{ assignment: NutritionAssignment }>()),
    selectDate: createAction(NutritionAction.SelectDate, props<{ date: number }>()),
    selectNutritionLocation: createAction(NutritionAction.SelectNutritionLocation, props<{ location: NutritionLocation }>()),
    selectNutritionLocationSetType: createAction(NutritionAction.SelectNutritionLocationSetType, props<{ locationSetType: string }>()),
    selectNutritionLocationSetTypeSuccess: createAction(NutritionAction.SelectNutritionLocationSetTypeSuccess),
    unselectLocation: createAction(NutritionAction.UnselectLocation)
};

export const AsyncActions = {
    loadActions: [
        NutritionActions.loadAssignments,
        NutritionActions.loadProfileOptions,
        NutritionActions.saveLocationAssignment
    ],
    successActions: [
        NutritionActions.loadAssignmentsSuccess,
        NutritionActions.loadProfileOptionsSuccess,
        NutritionActions.saveLocationAssignmentSuccess
    ],
    errorActions: [
        NutritionActions.loadAssignmentsFailure,
        NutritionActions.loadProfileOptionsFailure,
        NutritionActions.saveLocationAssignmentFailure
    ]
};
